// TODO(WEB): Plan for refactor relating to react-native-fs. This is a temporary shim
export const DocumentDirectoryPath = './'
export const downloadFile = { promise: Promise.resolve('this-will-crash-haha') }

export default {
  DocumentDirectoryPath,
  downloadFile,
}
